import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './authentication/login/login.component';
import {AuthenticatedGuard} from './authentication/shared/authenticated.guard';
import {PickUpListComponent} from './pick-up-list/pick-up-list/pick-up-list.component';
import {SearchFormComponent as PickuplistSearchFormComponent} from './pick-up-list/search-form/search-form.component';
import {UserManualComponent} from './help/user-manual/user-manual.component';
import {SearchFormComponent as MaterialSearchFormComponent} from './material/search-form/search-form.component';
import {MaterialListComponent} from './material/material-list/material-list.component';
import {PageNotFoundComponent} from './help/page-not-found/page-not-found.component';

const appRoutes: Routes = [
  {
    path: 'agency/:agencyISIL', children: [
      {path: 'login', component: LoginComponent},
      {path: 'pick-up-list/search', component: PickuplistSearchFormComponent, canActivate: [AuthenticatedGuard]},
      {path: 'pick-up-list/results', component: PickUpListComponent, canActivate: [AuthenticatedGuard]},
      {path: 'materials/search', component: MaterialSearchFormComponent, canActivate: [AuthenticatedGuard]},
      {path: 'materials/results', component: MaterialListComponent, canActivate: [AuthenticatedGuard]},
      {path: 'help', component: UserManualComponent, canActivate: [AuthenticatedGuard]},
      {path: '', pathMatch: 'full', redirectTo: 'pick-up-list/search'}
    ]
  },
  {path: '404', component: PageNotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts